import gql from 'graphql-tag';

const WDT_CHARACTERS_COMPLETED_AND_TIME_SPENT_QUERY = gql`
  query wdtCharactersCompletedAndTimeSpentReport(
    $where: WdtCharactersCompletedAndTimeSpentReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    wdtCharactersCompletedAndTimeSpentReport(where: $where, dateRange: $dateRange) {
      intervalUnit
      intervals {
        interval
        averageMinutesSpent
        charactersCompletedCount
      }
      totalCharactersCompletedCount
      averageMinutesSpent
    }
  }
`;

export default WDT_CHARACTERS_COMPLETED_AND_TIME_SPENT_QUERY;
